/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable max-len */
// @flow

import React, { Component } from 'react';
import * as DOMPurify from 'dompurify';

import CompetitionsInternationalesSingleMatchHighlights from 'components/competitionsInternationales/CompetitionsinternationalesSingleMatchHighlights';
import CompetitionsInternationalesSingleMatchStats from 'components/competitionsInternationales/CompetitionsinternationalesSingleMatchStats';
import PrevAndNextMatchesLinks from 'components/competitionsInternationales/PrevAndNextMatchesLinks';
import ContentBloc from 'components/newsletter/blocs/ContentBloc';
import { STATUS_SUCCESS } from 'constants/statusConstants';
import { withHelmet } from 'infrastructure/seo/Helmet';
import type { RencontreType } from 'types/Rencontre';
import type { Status } from 'types/Status';
import { formatFullDateString } from 'utils/dateUtils';

import CompetitionsInternationalesSingleMatchComposition from './CompetitionsinternationalesSingleMatchComposition';

import './CompetitionsInternationalesSingleMatch.css';

export type StateProps = {
  competition: {
    id: string,
    name: string,
    slug: string
  },
  rencontre: RencontreType,
  status: Status
};

type Props = StateProps;

type State = {
  activeComponent: string
};
class CompetitionsInternationalesSingleMatchLive extends Component<Props, State> {
  state: State = {
    activeComponent: '',
    offset: 0
  };

  render() {
    const {
      rencontre,
      rencontre: { content_match_live }
    } = this.props;
    const { activeComponent } = this.state;

    const firstTeam = !!rencontre.meta.reception ? 'France' : rencontre.meta.adversaire;
    const secondTeam = !rencontre.meta.reception ? 'France' : rencontre.meta.adversaire;
    const pageTitle = `Match ${firstTeam} vs ${secondTeam} <br /> ${formatFullDateString(
      new Date(rencontre.meta.date_rencontre)
    )}`;

    return (
      <div>
        <h2 className="page-title" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(pageTitle) }}></h2>

        <nav className="single-match__nav">
          <ul>
            <li
              className={activeComponent === '' ? 'active' : ''}
              onClick={() => this.setState({ activeComponent: '' })}
            >
              <span>Live Score</span>
            </li>
            <li
              className={activeComponent === 'composition' ? 'active' : ''}
              onClick={() => this.setState({ activeComponent: 'composition' })}
            >
              <span>Composition</span>
            </li>
            <li
              className={activeComponent === 'statistiques' ? 'active' : ''}
              onClick={() => this.setState({ activeComponent: 'statistiques' })}
            >
              <span>Statistiques</span>
            </li>
          </ul>
        </nav>

        {activeComponent === '' && <CompetitionsInternationalesSingleMatchHighlights rencontre={rencontre} />}

        {activeComponent === 'composition' && (
          <CompetitionsInternationalesSingleMatchComposition rencontre={rencontre} />
        )}

        {activeComponent === 'statistiques' && <CompetitionsInternationalesSingleMatchStats rencontre={rencontre} />}

        <PrevAndNextMatchesLinks prevAndNextMatchesLinks={rencontre.prev_and_next_match_links} />

        {!!content_match_live &&
          !!content_match_live.data &&
          !!content_match_live.data.length &&
          content_match_live.data.map((bloc, index) => <ContentBloc key={index} {...bloc} />)}
      </div>
    );
  }
}

export default withHelmet(CompetitionsInternationalesSingleMatchLive)((Helmet, pageProps: Props) => {
  const { competition, rencontre, status } = pageProps;

  if (status !== STATUS_SUCCESS || !competition || !rencontre) {
    null;
  }

  const firstTeam = !!rencontre.meta.reception ? 'France' : rencontre.meta.adversaire;
  const secondTeam = !rencontre.meta.reception ? 'France' : rencontre.meta.adversaire;

  const meta_title = `Match en Direct : ${firstTeam} vs ${secondTeam} - ${formatFullDateString(
    new Date(rencontre.meta.date_rencontre)
  )} - ${competition.name}`;

  return (
    <Helmet htmlAttributes={{ lang: 'fr' }}>
      {meta_title && <title>{meta_title}</title>}
      {meta_title && <meta property={'og:title'} content={meta_title} />}
    </Helmet>
  );
});
